import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { ReviewDataService } from '../../services/raintree/Transmission/review-data.service';
import { LoaderComponent } from '../../common-component/loader/loader.component';

import { DpLoaderComponent } from '../../common-component/dp-loader/dp-loader.component';
import { CommonModule } from '@angular/common';
import { UpdatedDataComponent } from './updated-data/updated-data.component';
import { MergeFcDataComponent } from './merge-fc-data/merge-fc-data.component';
import { CommonUtilService } from '../../services/common-util/common-util.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DpTabMenuV3Component } from '../../common-component/dp-tab-menu-v3/dp-tab-menu-v3.component';
@Component({
  selector: 'app-review-data',
  standalone: true,
  templateUrl: './review-data.component.html',
  styleUrl: './review-data.component.scss',
  imports: [
    RouterModule, FormsModule, ReactiveFormsModule,
    LoaderComponent,
    DpLoaderComponent,
    CommonModule,
    UpdatedDataComponent,
    MergeFcDataComponent,
    DpTabMenuV3Component
  ],
})
export class ReviewDataComponent implements OnInit {
  constructor(
    private _activatedRoute: ActivatedRoute,
    public route: ActivatedRoute,
    public reviewService: ReviewDataService,
    public router: Router,
    private isMobile: CommonUtilService,
  ) { }
  public isMobileDevice: boolean = false;
  public isLoading: boolean = false;
  permission: any
  breadcrumbs: any[] = ['All Countries', 'India']

  ngOnInit(): void {
    this.isLoading = true
    this.isMobileDevice = this.isMobile.isMobileDevice();
    this.addBreadCrumbs()
    this.isLoading = false
  }
  addBreadCrumbs() {
    this._activatedRoute.queryParams.subscribe((params) => {

      if (params['country'] && params['district'] && params['state'] && this.breadcrumbs.length === 2)
        this.breadcrumbs.push(params['state'], params['district'])
      if (params['country'] && params['state'] && !params['district'] && this.breadcrumbs.length === 4)
        this.breadcrumbs.pop()
      if (params['state'] && this.breadcrumbs.length === 2) {
        this.breadcrumbs.push(params['state']);
      }
      if (params['state'] && this.breadcrumbs.length === 3) {
        this.breadcrumbs[2] = params['state'];
      }
      if (params['district'] && this.breadcrumbs.length === 3) {
        this.breadcrumbs.push(params['district']);
      }
      if (params['district'] && this.breadcrumbs.length === 4) {
        this.breadcrumbs[3] = params['district'];
        this.breadcrumbs[2] = params['state']
      }
      if (Object.keys(params).length === 0) {
        this.removeBreadCrumbs(false)
      }
      this.isLoading = false;
    });
  }
  onBreadcrumbClick(index?: any) {
    this.isLoading = true
    if (index !== 0) {
      this.breadcrumbs.splice(index + 1)
      this.removeBreadCrumbs(true)
    }
  }
  removeBreadCrumbs(type: boolean) {
    let queryParams = { ...this._activatedRoute.snapshot.queryParams };

    if (type) {
      if (this.breadcrumbs.length === 2) {
        console.log(this.breadcrumbs, '1')
        delete queryParams['state'];
        delete queryParams['district'];
      }
      else {
        console.log(this.breadcrumbs, '2')
        delete queryParams['district'];
      }
      this.router.navigate([], {
        relativeTo: this._activatedRoute,
        queryParams: queryParams,
      });
    } else {
      this._activatedRoute.queryParams.subscribe((params) => {
        if (Object.keys(params).length === 0 && this.breadcrumbs.length > 1) {
          this.breadcrumbs = ['All countries', 'India']
        }

        if (!params['state'] && !params['district'])
          console.log('TEST')
      });
    }
  }
}
